<template>
  <a href="https://www.lemonsqueezy.com/buyer-terms" target="_blank" class="hover:text-wedges-gray-900">
    {{
      /* translators: Footer link that leads to the terms of usage page */
      $t('lemonsqueezy_checkout.terms')
    }}
  </a>
  <span>&middot;</span>
  <a href="https://www.lemonsqueezy.com/privacy" target="_blank" class="hover:text-wedges-gray-900">
    {{
      /* translators: Footer link that leads to the privacy policy page */
      $t('lemonsqueezy_checkout.privacy')
    }}
  </a>
  <span>&middot;</span>
  <a href="https://www.lemonsqueezy.com/help" target="_blank" class="hover:text-wedges-gray-900">
    {{
      /* translators: Footer link that leads to help docs */
      $t('lemonsqueezy_checkout.help')
    }}
  </a>
</template>
